import React from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  IconButton,
} from "@chakra-ui/react";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";
import { Comunication } from "../../types";

type Props = {
  comuncations: Comunication[];
  mt?: string;
  onEdit: (item: Comunication) => void;
  onDelete: (item: Comunication) => void;
};

export const ComunicationsTable: React.FC<Props> = ({
  comuncations,
  mt,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <Table variant="simple" size="lg" mt={mt}>
      <Thead bg={"#F0F2F4"} flex={1}>
        <Tr bg={"#F0F2F4"}>
          <Th color={"#7B8395"}>
            {t("screens.client.comunicationTableHead.data")}
          </Th>
          <Th color={"#7B8395"}>
            {t("screens.client.comunicationTableHead.operator")}
          </Th>
          <Th color={"#7B8395"}>
            {t("screens.client.comunicationTableHead.comunication_direction")}
          </Th>
          <Th color={"#7B8395"}>
            {t("screens.client.comunicationTableHead.duration")}
          </Th>
          <Th color={"#7B8395"}>
            {t("screens.client.comunicationTableHead.note")}
          </Th>
          <Th color={"#7B8395"}>AZIONI</Th>
        </Tr>
      </Thead>
      <Tbody>
        {comuncations.map((comuncation) => (
          <Tr>
            <Td>{comuncation.data.toLocaleDateString()}</Td>
            <Td>{comuncation.operator}</Td>
            <Td>{comuncation.comunicationDirection}</Td>
            <Td>{comuncation.duration}</Td>
            <Td>{comuncation.note}</Td>
            <Td>
              <Flex>
                <IconButton
                  aria-label="Delete comunication"
                  icon={<DeleteIcon />}
                  onClick={() => {
                    onDelete(comuncation);
                  }}
                  mx="3px"
                />
                <IconButton
                  aria-label="Edit comunication"
                  icon={<EditIcon />}
                  onClick={() => onEdit(comuncation)}
                  mx="3px"
                />
              </Flex>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};
